import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import tablesReducer from './slices/tablesSlice'
import sessionsReducer from './slices/sessionsSlice'
import usersReducer from './slices/usersSlice'
import tariffsReducer from './slices/tariffsSlice'
import uiReducer from './slices/uiSlice'
import bookingsReducer from './slices/bookingsSlice'
import localeReducer from './slices/localeSlice'
import markerNotificationsReducer from './slices/markerNotificationsSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        tables: tablesReducer,
        sessions: sessionsReducer,
        users: usersReducer,
        tariffs: tariffsReducer,
        ui: uiReducer,
        bookings: bookingsReducer,
        locale: localeReducer,
        markerNotifications: markerNotificationsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types for date objects
                ignoredActions: [
                    'tables/fetchTableDetails/fulfilled',
                    'sessions/fetchActiveSession/fulfilled'
                ],
                // Ignore these paths in the state
                ignoredPaths: [
                    'tables.tableDetailsCache',
                    'sessions.activeSessions'
                ]
            }
        }),
    devTools: process.env.NODE_ENV !== 'production'
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch